<app-toast-message></app-toast-message>
<app-loader></app-loader>

<!-- The trial bar sits above the layout so it spans the sidebar too; has-trial-banner
     publishes its height as a CSS variable the sidebar subtracts from its own. -->
<div
  *ngIf="
    (isAuthenticated$ | async) && userLoggedIn && !shellHidden;
    else notLoggedIn
  "
  class="app-shell flex flex-col h-screen overflow-hidden"
  [class.has-trial-banner]="(trial$ | async) !== null"
>
  <app-trial-banner [trial]="trial$ | async"></app-trial-banner>

  <nz-layout class="flex-1 min-h-0 overflow-hidden">
    <nz-sider
      nzCollapsible
      [nzCollapsed]="isCollapsed"
      [nzTrigger]="null"
      [nzWidth]="240"
      [nzCollapsedWidth]="56"
      class="relative z-50"
    >
      <!-- Logo and collapse btn -->
      <div
        class="flex items-center justify-between mt-4 mb-10 w-full h-10 group overflow-hidden"
        [ngClass]="!isCollapsed ? 'px-[18px]' : 'px-[14px]'"
      >
        <div class="logo transition-all duration-100">
          <app-svg-icon icon="icon-navbar-logo" class="w-[25px] h-[26px]" />
          <span
            class="spanvisible transition-opacity duration-100"
            [ngClass]="
              !isCollapsed ? 'opacity-100' : 'opacity-0 pointer-events-none'
            "
            ><span class="text-lg font-medium text-[#FFF]">Skenify</span></span
          >
        </div>

        <button
          class="bg-[#303D54] hover:bg-[#35445C] flex items-center justify-center h-10 w-10 rounded-lg transition-opacity duration-100"
          [customTooltip]="isCollapsed ? 'Open sidebar' : 'Close sidebar'"
          [ngClass]="
            !isCollapsed
              ? ''
              : 'absolute left-[7px] top-4 opacity-0 group-hover:opacity-100'
          "
          (click)="toggleSideNabar()"
        >
          <app-svg-icon icon="icon-layout-left" class="w-5 h-5" />
        </button>
      </div>

      <!-- Sidebar -->
      <app-sidebar
        [user]="user$ | async"
        [isCollapsed]="isCollapsed"
      ></app-sidebar>
    </nz-sider>

    <nz-layout id="layout-inner" class="bg-[#25282F] overflow-y-auto">
      <router-outlet></router-outlet>
    </nz-layout>
  </nz-layout>
</div>

<ng-template #notLoggedIn>
  <router-outlet></router-outlet>
</ng-template>
